module.exports = __webpack_public_path__ + "img/card.ddd859d1.svg";